import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBodyText, FDBox, FDIcon, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';

const HowToAchieveSection = ({ showMathSectionButton, onMathSectionButtonClick }) => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDStack direction={'column'} spacing={3} paddingY={5} paddingX={3} width={'100%'} {...dataAttrs('roadmap-goals-how-to-achieve-section')}>
      <MetaControlField attr={'title'} />
      <FDStack direction={'column'} spacing={2} width={'100%'}>
        {
          resource.attr('items').map((item) => (
            <FDStack direction={'row'} spacing={2} alignItems={'center'} width={'100%'}>
              <FDIcon icon={'arrowRight'} />
              <FDBodyText value={item} />
            </FDStack>
          ))
        }
      </FDStack>
      {showMathSectionButton ? (
        <FDBox>
          <FDSecondaryActionButton
            size={'sm'}
            label={'Show the math'}
            onClick={onMathSectionButtonClick}
            isFullWidth={false}
          />
        </FDBox>
      ) : null}
    </FDStack>
  );
};

HowToAchieveSection.defaultProps = {
};

HowToAchieveSection.propTypes = {
  showMathSectionButton: PropTypes.bool.isRequired,
  onMathSectionButtonClick: PropTypes.func.isRequired,
};

export default HowToAchieveSection;
